function resolveImageUrl(blobName: string): string {
  /**
   * NEXT_PUBLIC_* is inlined at BUILD time, so the container URL has to be set on the build, not as
   * an App Service application setting — see the Build step of .github/workflows/deploy-web.yml.
   * There is deliberately no fallback: a default would point every visitor's browser at a host that
   * only exists on a developer's machine.
   */
  const publicBaseUri = process.env.NEXT_PUBLIC_BLOB_STORAGE_URL;
  if (!publicBaseUri) return '';
  return `${publicBaseUri.replace(/\/+$/, '')}/${blobName}`;
}

/**
 * Upload responses occasionally carry the literal string "undefined" as blobName,
 * which would otherwise resolve to a valid-looking but broken URL.
 */
export function resolveAssetUrl(blobName?: string | null): string {
  if (!blobName || blobName === 'undefined') return '';
  return resolveImageUrl(blobName);
}
